import clientService from "../../services/clientService/service";
import ClientModel from "../../models/clientModel/model";

export default {
    async getClient(search, page, title, company) {
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
            const {data,headers} = await clientService.getClient(sanitizedSearch, page, title,company);
            return {
                data: data.map(client => new ClientModel(client)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching clients:', error);
            throw error;
        }
    },
    async totalAllClients(search,company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await clientService.totalAllClient(sanitizedSearch,company);
            return response.data;
        } catch (error) {
            console.error('Error fetching clients:', error);
            throw error;
        }
    },
    async addClient(client) {
        try {
            return await clientService.addClient(client);
        } catch (error) {
            console.error('Error adding client:', error);
            throw error;
        }
    },
    async updateClient(client) {
        try {
            return await clientService.updateClient(client);
        } catch (error) {
            console.error('Error updating client:', error);
            throw error;
        }
    },
    async deleteClient(clientId, clientGambar) {
        try {
            return await clientService.deleteClient(clientId, clientGambar);
        } catch (error) {
            console.error('Error deleting client:', error);
            throw error;
        }
    }
}